import { render, staticRenderFns } from "./QuickNotification.vue?vue&type=template&id=e59da8b0&scoped=true&"
import script from "./QuickNotification.vue?vue&type=script&lang=js&"
export * from "./QuickNotification.vue?vue&type=script&lang=js&"
import style0 from "./QuickNotification.vue?vue&type=style&index=0&id=e59da8b0&prod&lang=css&"
import style1 from "./QuickNotification.vue?vue&type=style&index=1&id=e59da8b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59da8b0",
  null
  
)

export default component.exports